import React from "react";
import Chart from "react-apexcharts";

function chartQC(data) {
	var data_series = [] ; 
	var data_label = [] ; 
	if(data.data.length > 0 ){
	for(let i = 0 ; i < data.data.length ; i++){
		data_series.push(data.data[i]["count_job"]);
		data_label.push(data.data[i]["job_category_name"]);
	}
	}
	else{
		data_series.push(0);
		data_label.push("");
	}
	const series = data_series;
	// const label_status = data_label;
	var options = {
		chart: {
			width: 500,
			type: 'donut',
		},
		dataLabels: {
            enabled: data.fact , 
            style: {
                fontSize: '10px',
            },
            formatter(val, opts) {
                const value = opts.w.globals.initialSeries[opts.seriesIndex] ; 
                const name = opts.w.globals.labels[opts.seriesIndex];
                return [value , name]
            }
        },
        colors:["#A83D8E", "#482080", "#2269AE", "#ECC419", "#5F7C36", "#DD8524", "#1C3583", '#4E6641',
        '#BEBB56',
        '#FFBC47',
        '#AC3E1A',
        '#6F0A12',
        '#4D2221',
        '#6A4531',
        '#DA6B42',
        '#8F4150',
        '#DA6B42',
        '#624489',
        '#1A3164',
        '#579E98',
        '#ACA57B',
        '#7F92AE', "#FF0000"],
        fill: {
            colors:["#A83D8E", "#482080", "#2269AE", "#ECC419", "#5F7C36", "#DD8524", "#1C3583", '#4E6641',
            '#BEBB56',
            '#FFBC47',
            '#AC3E1A',
            '#6F0A12',
            '#4D2221',
            '#6A4531',
            '#DA6B42',
            '#8F4150',
            '#DA6B42',
            '#624489',
            '#1A3164',
            '#579E98',
            '#ACA57B',
            '#7F92AE', "#FF0000"],
        },
		labels: data_label,
		responsive: [{
			// breakpoint: 800,
			options: {
				chart: {
					width: "300px"
				},
				legend: {
					show: true,
				},

			}
		}],
		legend: {
			show: false,
			fontSize: '9px',
			position: 'bottom',
			horizontalAlign: 'center',
			markers: {
				width: 5,
				height: 5,
				strokeWidth: 0,
				strokeColor: '#fff',
				radius: 12,
				onClick: undefined,
				offsetX: 0,
				offsetY: 0
			},
		},
		stroke: {
			width: 0,
			colors: ["#fff"]
		},
		plotOptions: {
			pie: {
				customScale: 1,
				donut: {
					labels: {
						show: true,
						total: {
							show: true,
							label: 'Jobs',
							fontSize: '10x',
							fontFamily: 'Montserrat, sans-serif',
							fontWeight: 400,
							color: '#41434A',
							formatter: function (w) {
								return w.globals.seriesTotals.reduce((a, b) => {
									return a + b
								}, 0)
							}
						}
					},

				},

			},
		},
	};


	return (

		<Chart options={options} series={series} type="donut" />

	)
}

export default chartQC














